// Semester Calls
const getSemesters = async () => {
    let rawString = localStorage.getItem('semesters');
    let toReturn = [];
    if (rawString) {
        toReturn = JSON.parse(rawString);
    }
    return toReturn;
}
const addSemester = async (semesterToAdd) => {
    let semesterList = localStorage.getItem('semesters');
    if (semesterList) {
        semesterList = JSON.parse(semesterList);
    } else {
        semesterList = [];
    }
    let nextId = ((list) => {
        let max = -1;
        for (let item of list) {
            if (max < item.id) {
                max = item.id
            }
        }
        return max + 1;
    })(semesterList);
    let toReturn = { ...semesterToAdd, id: nextId };
    semesterList = [...semesterList, toReturn];
    localStorage.setItem('semesters', JSON.stringify(semesterList));
    return toReturn;
}
const removeSemester = async (semesterIdToRemove) =>{
    const classes = await getClasses(semesterIdToRemove);
    for (const clas in classes) {
        await removeClass(classes[clas].id);
    }
    let semesterList = localStorage.getItem('semesters');
    if (semesterList) {
        semesterList = JSON.parse(semesterList);
    } else {
        semesterList = [];
    }
    semesterList = semesterList.filter((item) => {
        return item.id !== Number(semesterIdToRemove);
    })
    localStorage.setItem('semesters', JSON.stringify(semesterList));
}
const getSemester = async (semesterid) => {
    let semesterList = localStorage.getItem('semesters');
    if (semesterList) {
        semesterList = JSON.parse(semesterList);
    } else {
        semesterList = [];
    }
    let toReturn = semesterList.find((item) => {
        return item.id === Number(semesterid)
    });
    return toReturn;
}

// Class Calls
const getClasses = async (semesterid) => {
    let classesDatabase = localStorage.getItem('classes');
    if (classesDatabase) {
        classesDatabase = JSON.parse(classesDatabase);
    } else {
        classesDatabase = [];
    }
    let classes = classesDatabase.filter((item) => {
        return item.semesterId === Number(semesterid);
    })
    return classes;
}
const addClass = async (newClass, semesterid) => {
    let classesDatabase = localStorage.getItem('classes');
    if (classesDatabase) {
        classesDatabase = JSON.parse(classesDatabase);
    } else {
        classesDatabase = [];
    }
    let nextId = ((list) => {
        let max = -1;
        for (let item of list) {
            if (max < item.id) {
                max = item.id
            }
        }
        return max + 1;
    })(classesDatabase);
    const toSave = { ...newClass, id: nextId,semesterId:Number(semesterid) };
    classesDatabase = [...classesDatabase, toSave];
    localStorage.setItem('classes', JSON.stringify(classesDatabase));
    return toSave;
}
const removeClass = async (classIdToRemove) => {
    let classesDatabase = localStorage.getItem('classes');
    if (classesDatabase) {
        classesDatabase = JSON.parse(classesDatabase);
    } else {
        classesDatabase = [];
    }
    classesDatabase = classesDatabase.filter((item) => {
        return item.id !== Number(classIdToRemove);
    })
    localStorage.setItem('classes', JSON.stringify(classesDatabase));
    let students = await getStudents(classIdToRemove);
    for (let student of students) {
        await removeStudent(student.id);
    }
}
const getClass = async (classid) => {
    let classesDatabase = localStorage.getItem('classes');
    if (classesDatabase) {
        classesDatabase = JSON.parse(classesDatabase);
    } else {
        classesDatabase = [];
    }
    let toReturn = classesDatabase.find((item) => {
        return item.id === Number(classid);
    })
    return toReturn;
}

// Student Calls
const addStudent = async (newStudent, classid) => {
    let studentDatabase = localStorage.getItem('students');
    if (studentDatabase) {
        studentDatabase = JSON.parse(studentDatabase);
    } else {
        studentDatabase = [];
    }
    let nextId = ((list) => {
        let max = -1;
        for (let item of list) {
            if (max < item.id) {
                max = item.id
            }
        }
        return max + 1;
    })(studentDatabase);
    const toSave = { ...newStudent, classId: parseInt(classid), id: nextId };
    studentDatabase = [...studentDatabase, toSave];
    localStorage.setItem('students',JSON.stringify(studentDatabase));
    return toSave;
}
const removeStudent = async (studentIdToRemove) => {
    let studentDatabase = localStorage.getItem('students');
    if (studentDatabase) {
        studentDatabase = JSON.parse(studentDatabase);
    } else {
        studentDatabase = [];
    }
    studentDatabase = studentDatabase.filter((item) => {
        return item.id !== Number(studentIdToRemove);
    })
    localStorage.setItem('students', JSON.stringify(studentDatabase));
}
const getStudents = async (classid) => {
    let studentDatabase = localStorage.getItem('students');
    if (studentDatabase) {
        studentDatabase = JSON.parse(studentDatabase);
    } else {
        studentDatabase = [];
    }
    let toReturn = studentDatabase.filter((item) => {
        return item.classId === Number(classid);
    });
    return toReturn;
}
const getStudent = async (studentid) => {
    let studentDatabase = localStorage.getItem('students');
    if (studentDatabase) {
        studentDatabase = JSON.parse(studentDatabase);
    } else {
        studentDatabase = [];
    }
    let toReturn = studentDatabase.find((item) => {
        return item.id === Number(studentid);
    });
    return toReturn;
}
const updateStudent = async (id, toSave) => {
    let studentDatabase = localStorage.getItem('students');
    if (studentDatabase) {
        studentDatabase = JSON.parse(studentDatabase);
    } else {
        studentDatabase = [];
    }
    let indexOfStudent = studentDatabase.findIndex((item) => {
        return item.id === Number(id);
    });
    Object.entries(toSave).forEach(([key, value]) => {
        studentDatabase[indexOfStudent][key] = value;
    });
    localStorage.setItem('students', JSON.stringify(studentDatabase));
    let toReturn = studentDatabase[indexOfStudent];
    return toReturn;
}

// Add functions to exports
let data = {};
// Semesters
data.getSemesters = getSemesters;
data.addSemester = addSemester;
data.removeSemester = removeSemester;
data.getSemester = getSemester;
// Classes
data.getClasses = getClasses;
data.addClass = addClass;
data.removeClass = removeClass;
data.getClass = getClass;
// Students
data.addStudent = addStudent;
data.removeStudent = removeStudent;
data.getStudents = getStudents;
data.getStudent = getStudent;
data.updateStudent = updateStudent;

export default data;